import {useEffect, useState} from 'react';
import type {PDFDocumentLoadingTask, PDFDocumentProxy} from 'pdfjs-dist/legacy/build/pdf.mjs';
import * as pdfjs from 'pdfjs-dist/legacy/build/pdf.mjs';
import {wasmUrl} from './pdfjsSetup';

/**
 * No-ops (returns null) while `file` is undefined, and destroys the previous document on change/unmount.
 */
export function usePdfDocument(file: Blob | undefined): { pdf: PDFDocumentProxy | null; error: string } {
    const [pdf, setPdf] = useState<PDFDocumentProxy | null>(null);
    const [error, setError] = useState('');

    useEffect(() => {
        let cancelled = false;
        let loaded: PDFDocumentLoadingTask | null = null;
        setPdf(null);
        setError('');
        if (!file) {
            return;
        }
        (async () => {
            try {
                const data = await file.arrayBuffer();
                const task = pdfjs.getDocument({data, wasmUrl});
                const doc = await task.promise;
                if (cancelled) {
                    task.destroy();
                    return;
                }
                loaded = task;
                setPdf(doc);
            } catch (e: any) {
                if (!cancelled) {
                    setError(String(e?.message ?? e));
                }
            }
        })();
        return () => {
            cancelled = true;
            loaded?.destroy();
        };
    }, [file]);

    return {pdf, error};
}
